import { Fragment, FunctionComponent, useState } from 'react'
import { Button, Link } from '@conexasaude/hero'
import { unansweredNps } from '@/modules/NPS/nps-services'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'

const FooterCancelledModal: FunctionComponent<{
  canSchedule: boolean
  hookSuccess()
  hookFailed()
  buttonNameScheduled: string
  buttonNameImmediate: string
}> = ({
  canSchedule,
  hookSuccess,
  hookFailed,
  buttonNameScheduled,
  buttonNameImmediate,
}) => {
  const [loading, setLoading] = useState<boolean>()

  const { embed } = useThemeGeneratorContext()
  const { closeModal } = useModalContext()
  return (
    <div className="d-flex justify-content-end flex-lg-row flex-column-reverse w-100 footer-modal-buttons">
      {canSchedule && !embed.full ? (
        <Fragment>
          <Link
            onClick={() => {
              closeModal()
              hookFailed()
            }}
          >
            Agora não
          </Link>
          <Button
            style={{ marginLeft: '5px' }}
            onClick={() => {
              closeModal()
              hookSuccess()
            }}
          >
            {buttonNameScheduled}
          </Button>
        </Fragment>
      ) : (
        <Button
          style={{ marginLeft: '5px' }}
          className="gndi-avaliacao-confirmada"
          busy={loading}
          onClick={async () => {
            if (embed.full) {
              setLoading(true)
              await unansweredNps()
              return
            }
            closeModal()
            hookSuccess()
          }}
        >
          {buttonNameImmediate}
        </Button>
      )}
    </div>
  )
}

export default FooterCancelledModal
